import { useQuery } from '@tanstack/react-query';
import { customerServices } from '../services/customer.service';

export const useCustomer = (customerId) => {
  return useQuery({
    queryKey: ['customer', customerId],
    queryFn: () => customerServices.getCustomer(customerId),
    enabled: !!customerId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
